import Vue from 'vue';
import { BfSpinner, BfButton } from "components/Butterfly";
import Site from 'src/api/site';
import Project from 'src/api/project';
import UserTypeSelect from 'src/components/account/UserList/UserTypeSelect.vue';
import { arrayToTree } from 'src/utils/arrayToElTree';
export default Vue.extend({
    name: 'SiteUsersList',
    components: { BfSpinner, BfButton, UserTypeSelect },
    props: {
        visible: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: true,
            waitingForResponse: false,
            error: undefined,
            dropdownVisible: false,
            formData: {
                email: '',
                userType: 'ANALYST',
                projects: [],
                dashboards: [],
            },
            filterTextProjects: '',
            filterTextDashboards: '',
            projectOptions: [],
            dashboardOptions: [],
            props: {
                label: 'name',
                children: 'children',
            },
            rules: {
                email: [
                    { required: true, message: 'Email is required', trigger: 'blur' },
                ],
            },
        };
    },
    watch: {
        filterTextProjects(val) {
            this?.$refs?.projectTree?.filter(val);
        },
        filterTextDashboards(val) {
            this?.$refs?.dashboardTree?.filter(val);
        },
    },
    mounted() {
        this.fetchProjectOptions();
        this.fetchDashboardOptions();
    },
    methods: {
        preventCloseOnFocus(event) {
            if (this.dropdownVisible) {
                event.stopImmediatePropagation();
            }
        },
        clearAndClose() {
            this.$refs.form.resetFields();
            this.formData = {
                email: '',
                userType: 'ANALYST',
                projects: [],
                dashboards: [],
            },
                this.error = undefined;
            this.waitingForResponse = false;
            const pt = this?.$refs?.projectTree;
            if (pt)
                pt.setCheckedNodes([{}]);
            const dt = this?.$refs?.dashboardTree;
            if (dt)
                dt.setCheckedNodes([{}]);
            this.$emit('close');
        },
        handleUserTypeChange(type) {
            this.formData.userType = type;
            this.formData.projects = [];
            this.formData.dashboards = [];
        },
        async fetchProjectOptions() {
            this.loading = true;
            const response = await Project.searchProjects('');
            if (!this)
                return;
            this.projectOptions = response.map((project) => {
                return {
                    name: project.name,
                    id: project.id,
                };
            });
            this.loading = false;
        },
        async fetchDashboardOptions() {
            this.loading = true;
            const response = await Project.getAllDashboards();
            if (!this)
                return;
            this.dashboardOptions = arrayToTree(response, 'analysis', 'analysis_name', 'project_id', 'project_name');
            this.loading = false;
        },
        filterNode(value, data) {
            if (!value)
                return true;
            return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        async inviteUser() {
            this.error = '';
            try {
                await (this.$refs.form.validate());
            }
            catch {
                return;
            }
            this.waitingForResponse = true;
            try {
                await Site.createMembershipInvitation(this.formData.email, this.formData.userType, this.formData.projects.map(p => p.id), this.formData.dashboards.map(d => d.id));
                this.$emit('user-invited', this.formData.email);
                this.$analytics.track.site.inviteUser(this.formData.email, this.formData.userType);
                this.clearAndClose();
            }
            catch (e) {
                const r = await e.json();
                this.error = r?.non_field_errors?.join(', ') ?? 'Failed to invite user';
            }
            finally {
                this.waitingForResponse = false;
            }
        },
        handleProjectCheck() {
            this.formData.projects = this.$refs.projectTree.getCheckedNodes(true);
        },
        handleDashboardCheck() {
            this.formData.dashboards = this.$refs.dashboardTree.getCheckedNodes(true);
        },
    },
});
